












































































import { Component, Prop, Vue } from "vue-property-decorator";
import { RiwayatRah } from "@/types/rekam_asuhan_hemodialisis";

type StatusTtd = { label: string; nama: string | null; signedAt: string | null };

@Component
export default class RiwayatPengisianHemodialisis extends Vue {
  @Prop({ type: Array, required: true }) readonly riwayat!: RiwayatRah[];
  @Prop({ type: [String, Number], required: true }) readonly register!: string | number;
  @Prop({ default: null }) readonly selectedId!: number | null;
  @Prop({ default: null }) readonly printingId!: number | null;

  headers = [
    { text: "Tanggal/Jam HD", value: "waktu_hd", width: "140px" },
    { text: "No. Register", value: "register_id", width: "190px" },
    { text: "Perawat", value: "perawat", sortable: false },
    { text: "Dokter", value: "dokter", sortable: false },
    { text: "", value: "aksi", sortable: false, align: "end", width: "180px" }
  ];

  get jumlahKunjunganIni(): number {
    return this.riwayat.filter(it => this.kunjunganIni(it)).length;
  }

  kunjunganIni(item: RiwayatRah): boolean {
    return String(item.register_id) === String(this.register);
  }

  ttdPerawat(item: RiwayatRah): StatusTtd[] {
    return [{ label: "Perawat", nama: item.perawat_nama, signedAt: item.perawat_signed_at }];
  }

  ttdDokter(item: RiwayatRah): StatusTtd[] {
    return [
      { label: "TTD 1", nama: item.dokter_nama, signedAt: item.dokter_signed_at },
      { label: "TTD 2", nama: item.dokter_catatan_nama, signedAt: item.dokter_catatan_signed_at }
    ];
  }

  kelasBaris(item: RiwayatRah): string {
    return item.id === this.selectedId ? "baris-terpilih" : "";
  }

  formatDateTime(v: string | null): string {
    if (!v) return "-";
    const [tgl, jam = ""] = v.split(" ");
    const [y, m, d] = tgl.split("-");

    return `${d}-${m}-${y}${jam ? " " + jam.slice(0, 5) : ""}`;
  }
}
